module.exports = __webpack_public_path__ + "static/img/no_content.4c3ef33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_content.png
// module id = zzuQ
// module chunks = 190